/**
 * HTMLDialogElement polyfill script for Google Places API compatibility.
 * This polyfill is needed for browsers that don't support the HTMLDialogElement interface.
 *
 * @see apps/infrastructure/views/application/_google_places_api.html.erb for the original implementation
 * @see https://git.fullscript.io/developers/hw-admin/-/issues/58256
 */
const DialogPolyfillScript = () => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          if (typeof window !== 'undefined' && !('HTMLDialogElement' in window)) {
            // Mock the HTMLDialogElement initially to avoid the console error spammed by the Google Maps API
            window.HTMLDialogElement = class {
              constructor() {
                this.open = false;
              }
              showModal() {
                this.open = true;
              }
              close() {
                this.open = false;
              }
            };

            // Load the polyfill dynamically for unsupported browsers
            var script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/dialog-polyfill@0.5.5/dist/dialog-polyfill.min.js';
            script.onload = function() {
              // MutationObserver to watch for dialog elements added to the DOM
              const observer = new MutationObserver(function(mutations) {
                // Check if any <dialog> elements were added
                mutations.forEach(function(mutation) {
                  mutation.addedNodes.forEach(function(node) {
                    if (node.tagName === 'DIALOG') {
                      dialogPolyfill.registerDialog(node);
                    }
                  });
                });
              });

              // Observe the entire document for added nodes
              observer.observe(document.body, {
                childList: true,
                subtree: true
              });

              // Register the polyfill for each <dialog> element found in the DOM
              document.querySelectorAll('dialog').forEach(dialog => {
                dialogPolyfill.registerDialog(dialog);
              });

              // Dynamically inject the necessary CSS for dialogs
              var style = document.createElement('style');
              style.textContent = \`
                dialog[open] {
                  display: block;
                }

                dialog {
                  background: white;
                  border: solid 1px #ccc;
                  border-radius: 8px;
                  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                  max-width: 500px;
                  margin: auto;
                  padding: 20px;
                  position: fixed;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  z-index: 1000;
                  visibility: hidden;
                  opacity: 0;
                  transition: opacity 0.3s ease;
                }

                dialog[open] {
                  visibility: visible;
                  opacity: 1;
                }
              \`;
              document.head.appendChild(style);
            };
            document.head.appendChild(script);
          }
        `,
      }}
    />
  );
};

export { DialogPolyfillScript };
